var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.776 3-1.062 8.583C2.812 13.4 1 15.979 1 18.838c0 5.506 6.716 9.97 15 9.97s15-4.464 15-9.97c0-2.892-1.854-5.497-4.815-7.318L25.13 3l-4.897 6.272A22.134 22.134 0 0 0 16 8.87c-1.5 0-2.948.146-4.314.418L6.776 3zM8.64 13.994c-.746.67-1.305 1.77-1.49 2.236a10.48 10.48 0 0 0 2.049-1.398c.395-.356.774-.51 1.08-.635.412-.168.689-.28.689-.762-.001-.839-1.399-.28-2.33.559zm3.354 1.956.931-.559 1.212 1.492h3.913l1.21-1.49.932.558-4.099 6.429-4.1-6.43zm2.515 1.864H17.676l-1.584 2.142-1.584-2.142zm9.037-3.82c.745.67 1.304 1.77 1.49 2.236a10.48 10.48 0 0 1-2.05-1.398c-.396-.356-.775-.51-1.08-.635-.413-.168-.69-.28-.69-.762 0-.839 1.398-.28 2.33.559z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMona);
export default __webpack_public_path__ + "static/media/MONA.955707f3383d9b0b431f75b6ec54493d.svg";
export { ForwardRef as ReactComponent };